import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { ToolHeader, FoundingCTA, PoweredBy } from "./ToolShell";
import HealthScore from "./HealthScore";
import { TOOLS } from "./toolkit";

const ToolCard = ({ t, i }) => (
  <Link to={`/tools/${t.slug}`}
    className="group border border-border bg-card rounded-sm p-6 flex flex-col hover:border-primary hover:-translate-y-0.5 transition-[transform,border-color] duration-300 animate-in fade-in slide-in-from-bottom-2"
    style={{ animationDelay: `${i * 70}ms`, animationFillMode: "both" }} data-testid={`tools-card-${t.key}`}>
    <div className="flex items-center justify-between">
      <t.icon className="w-7 h-7 text-primary" />
      <span className="text-[10px] font-mono-plex uppercase tracking-widest text-muted-foreground">{t.minutes}</span>
    </div>
    <div className="font-display font-bold text-xl mt-5">{t.title}</div>
    <p className="text-sm text-muted-foreground mt-2 flex-1">{t.desc}</p>
    <span className="mt-5 text-sm text-primary inline-flex items-center">Open tool <ArrowRight className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" /></span>
  </Link>
);

export default function ToolsHub() {
  useEffect(() => { document.title = "Free Manufacturing Tools — OEE, 5S, CAPA | RuleAI Systems"; }, []);
  return (
    <div className="dark min-h-screen bg-background text-foreground" data-testid="tools-hub">
      <ToolHeader />
      <section className="border-b border-border grid-lines">
        <div className="max-w-6xl mx-auto px-5 lg:px-10 py-14 md:py-20">
          <div className="overline text-accent">◉ Free · No login · Works on the floor</div>
          <h1 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tight mt-3 max-w-4xl" data-testid="tools-hub-title">
            The Manufacturing Excellence <span className="text-primary">Toolkit.</span>
          </h1>
          <p className="text-muted-foreground text-sm md:text-lg mt-5 max-w-2xl">Six interactive tools plant managers and CI engineers actually use — calculate, audit, print and share in minutes. Your results stay in your browser.</p>
        </div>
      </section>
      <main className="max-w-6xl mx-auto px-5 lg:px-10 py-10 space-y-8">
        <HealthScore />
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {TOOLS.map((t, i) => <ToolCard key={t.key} t={t} i={i} />)}
        </div>
        <p className="text-sm text-muted-foreground">Looking for SOP templates and downloads? <Link to="/library" className="text-primary hover:underline" data-testid="tools-hub-library-link">Browse the resource library →</Link></p>
      </main>
      <FoundingCTA />
      <PoweredBy />
    </div>
  );
}
